module.exports = __webpack_public_path__ + "img/IMG_0374_L_Black.08d79f71.jpg";